<template>
	<div class="appAgreement">
		<div class="text" v-html="content"></div>
	</div>
</template>

<script>
	export default {
		name:'appAgreement',
		data() {
			return {
				type:2,
				content:null,
				loading:false
			}
		},
		created() {
			if(this.$route.query.type) this.type = this.$route.query.type
			this.getAgreement()
		},
		watch:{
			$route() {
				if(this.$route.query.type) this.type = this.$route.query.type
				this.getAgreement()
			}
		},
		methods: {
			getAgreement(){
				this.$axios.get('/api/client/Common/getAgreements',{params:{id:this.type}}).then(res=>{
					if(res.code==200){
						this.content = res.data.content
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.appAgreement{
		padding: 14px;
		background: #FFFFFF;
		min-height: 100vh;
		.text{
			text-align: justify;
		}
	}
</style>